module.exports = __webpack_public_path__ + "static/media/es3.98fa81b8.png";